module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vpelv3-f5b5eab77f5ee463efcfa3fcccb036d2.jpg";